module.exports = __webpack_public_path__ + "assets/8f219e03e4894cd7b34d0b8158aa6447.png";